import { OmsOrderDetail } from 'types/oms';
import { Trans } from 'react-i18next';
import LOCALS from 'commons/locals';
import { getMemberPointHistoryListV2 } from 'apis/ums';
import { useEffect, useMemo, useState } from 'react';
import { UmsMemberPointHistoryV2 } from 'types/ums';
import formatTime from 'utils/formatTime';
import Table, { ColumnsType } from 'antd/es/table';
import { Card } from 'antd';
import { Gift } from 'lucide-react';

type OrderPointHistoriesProps = {
  orderId: OmsOrderDetail['id'];
};

const OrderPointHistories = ({ orderId }: OrderPointHistoriesProps) => {
  const [pointHistoryList, setPointHistoryList] = useState<
    UmsMemberPointHistoryV2[]
  >([]);

  useEffect(() => {
    getMemberPointHistoryListV2({ pageNum: 1, pageSize: 100, orderId }).then(
      (res) => {
        setPointHistoryList(res.list);
      }
    );
  }, [orderId]);

  const columns: ColumnsType<UmsMemberPointHistoryV2> = useMemo(() => {
    return [
      {
        title: <Trans i18nKey={LOCALS.change_amount}></Trans>,
        dataIndex: 'changeCount',
        key: 'changeCount',
      },
      {
        title: <Trans i18nKey={LOCALS.operator}></Trans>,
        dataIndex: 'operateMan',
        key: 'operateMan',
      },
      {
        title: <Trans i18nKey={LOCALS.note}></Trans>,
        dataIndex: 'operateNote',
        key: 'operateNote',
      },
      {
        title: <Trans i18nKey={LOCALS.created_time}></Trans>,
        dataIndex: 'createTime',
        key: 'createTime',
        render: (createTime: UmsMemberPointHistoryV2['createTime']) => {
          return formatTime(createTime);
        },
      },
    ];
  }, []);

  if (pointHistoryList.length === 0) return null;

  return (
    <Card bodyStyle={{ padding: '16px' }} >
      <div className="flex items-center gap-2 mb-4 text-base font-medium">
        <Gift className="w-5 h-5" />
        <Trans i18nKey={LOCALS.point_history} />
      </div>
      <Table
        size="small"
        bordered
        pagination={false}
        rowKey={'id'}
        tableLayout="auto"
        scroll={{ x: 'max-content' }}
        dataSource={pointHistoryList}
        columns={columns}
      />
    </Card>
  );
};

export default OrderPointHistories;
